export const pettycashStatusTypeMap = {
  approved: "aprobado",
  requested: "pendiente",
  rejected: "rechazado",
  paid:"pagado"
}